import React from "react";
import "../App.css";

const Projects = () => {
  return (
    <section className="projects-section">
      <div className="projects-container">
        {/* Projects Title */}
        <h2 className="projects-title">Projects</h2>

        {/* Countdown to 100K Project */}
        <a
          href="https://ray-banks.com/countdown-to-100k/"
          target="_blank"
          rel="noopener noreferrer"
          className="project-card red-hover"
        >
          <div className="project-image-container">
            <img
              src="./yt-100k-light-red.png"
              alt="Countdown to 100K"
              className="default-image"
            />
            <img
              src="yt-100k-red.png"
              alt="Countdown to 100K Hover"
              className="hover-image"
            />
          </div>
          <h3>Countdown to 100K</h3>
          <p>Get an estimate of how soon you'll get to 100K YT subscribers and get a silver play button!</p>
          <div className="project-links">
            <a href="https://github.com/rayhbanks/countdown-to-100k">GitHub</a>
            <a href="https://ray-banks.com/countdown-to-100k/">Live Demo</a>
          </div>
        </a>

        {/* Where I've Been Inclusive (WIBI) Project */}
        <a
          href="https://ray-banks.com/wibi-app/"
          target="_blank"
          rel="noopener noreferrer"
          className="project-card blue-hover"
        >
          <div className="project-image-container">
            <img
              src="./where-ive-been-blue.png"
              alt="Where I've Been Default"
              className="default-image"
            />
            <img
              src="./where-ive-been-white.png"
              alt="Where I've Been Hover"
              className="hover-image"
            />
          </div>
          <h3>Where I've Been - Inclusive</h3>
          <p>Track the countries you've been to and choose whichever countries you'd like to count e.g. Taiwan, Palestine, etc. (map coming soon).</p>
          <div className="project-links">
            <a href="https://github.com/rayhbanks/wibi-app">GitHub</a>
            <a href="https://ray-banks.com/wibi-app/">Live Demo</a>
          </div>
        </a>
        {/* My Portfolio Project */}
        <a
          href="https://ray-banks.com"
          target="_blank"
          rel="noopener noreferrer"
          className="project-card yellow-hover"
        >
          <div className="project-image-container">
            <img
              src="./portfolio-screenshot.png"
              alt="Ray's portfolio screenshot"
              className="default-image"
            />
            <img
              src="./portfolio-screenshot-hover.png"
              alt="Ray's portfolio screenshot Hover"
              className="hover-image"
            />
          </div>
          <h3>My Portfolio</h3>
          <p>This is my portfolio website which I created to practice learning React and showcase my work.</p>
          <div className="project-links">
            <a href="https://github.com/rayhbanks/Ray-Banks-Portfolio">GitHub</a>
            <a href="https://ray-banks.com">Live Demo</a>
          </div>
        </a>
                {/* Ji Chinese Flashcards Project */}
                <a
          href="https://apps.apple.com/us/app/ji-chinese-flashcards/id6741540532"
          target="_blank"
          rel="noopener noreferrer"
          className="project-card green-hover"
        >
          <div className="project-image-container">
            <img
              src="./ji-chinese-green.png"
              alt="Ji Chinese Flashcards App"
              className="default-image"
            />
            <img
              src="./ji-chinese-black.png"
              alt="Ji Chinese Flashcards App Hover"
              className="hover-image"
            />
          </div>
          <h3>Ji Chinese Flashcards</h3>
          <p>The fastest way to learn Chinese characters, bopomofo and track all your progress along the way. Now live on the Apple App Store!</p>
          <div className="project-links">
            <a href="https://apps.apple.com/us/app/ji-chinese-flashcards/id6741540532">Live Demo</a>
          </div>
        </a>

      </div>
    </section>
  );
};

export default Projects;